import {useEffect} from 'react';


export const useSAYT = (searchOpen, setSearchOpen, closeAll) => useEffect(() => {
	const sayt = (e) => {
		var patt = /input|textarea|select/i,
			plet = /\w/i,
			char = String.fromCharCode(
				e.keyCode || e.which || e.charCode
			),
			cmd = false;
		if (
			navigator.platform.match(/(Mac|Win32|iPod|iPad)/i) &&
			(
				e.metaKey ||
				(
					e.keyCode == 224 &&
					navigator.userAgent.toLowerCase().indexOf("firefox") >= 0
				) 
				||
				(e.keyCode == 17 &&
					navigator.userAgent
						.toLowerCase()
						.indexOf("opera") >= 0) ||
				((e.keyCode == 91 || e.keyCode == 93) &&
					navigator.userAgent
						.toLowerCase()
						.indexOf("webkit") >= 0))
		) {
			cmd = true;
		}
		if (searchOpen && ((e.keyCode || e.which) == 27) || e.key == "Escape" || e.key == "Esc") {
			closeAll();
		}

		if (
			(
				(
					!document.body.classList.contains('keyboard-focused') && // nao esteja com selects abertos
					(
						!patt.test(e.target.tagName)  // não é input
					 	|| e.target.id === "search-ipt" // pode ser o input da pesquisa
				 	)
				) &&
				e.target.getAttribute('contenteditable') != "true" && // não é editable
				plet.test(char) && // é um char
				!e.altKey && // sem alt
				!e.ctrlKey && // sem ctrl
				( // não é uma tecla fx
					(e.keyCode || e.which) < 112 ||
					(e.keyCode || e.which) > 123 
				) &&
				!cmd  // não é tecla de cmd do mac
			)
			|| ((cmd || e.ctrlKey) && e.which == 81) // ctrl|cmd + q (opens search)
		) {
			if(!searchOpen) {
				setSearchOpen(true);
			}
		}
	}

	window.addEventListener("keypress", sayt, false);
	window.addEventListener("keydown", sayt, false);
	return () => {
		window.addEventListener("keypress", sayt, false);
		window.addEventListener("keydown", sayt, false);
	}
}, [1]);

